import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.61 18.79L26.4 29.58L28.9 29.65L28.83 25.24L27.13 25.21L25.28 23.37H23.69L22.59 22.27V20.8L20.35 18.55L20.44 16.66L19.09 15.3L15.61 18.79Z" fill="#5586D4" />
      <path
        d="M15.59 4.18001L10.32 2.35001L3.09 9.58001L4.8 15L14.07 18.27L18.51 13.83L15.59 4.18001ZM6.62 11.08L5.37 9.83001L10.45 4.75001L11.7 6.00001L6.62 11.08Z"
        fill="#1F3E74"
      />
    </svg>
  );
};

export default Icon;
